module.exports = __webpack_public_path__ + "img/Logo Charuzit_Blue_Circle.21a0a72a.png";